import { useState } from 'react'
import { useT } from './i18n-context.js'

/**
 * Описание записи SRD: русский перевод, английский оригинал по кнопке.
 *
 * Одно место на весь лист (D32). Русское описание — основное; кнопка
 * «Оригинал» открывает английский текст рядом, а не вместо. Не общим
 * переключателем языка: перевод сверяют с источником поштучно, на
 * одной особенности, а не «включаю английский на весь экран».
 *
 * Атрибут `lang` у каждого текста свой — иначе синтезатор речи
 * прочтёт английский по-русски, а браузер перенесёт слова по чужим
 * правилам.
 *
 * Записи без перевода показываются по-английски: заходы идут по видам
 * записей, и запись без перевода — не ошибка, а ещё не сделанная работа.
 *
 * `inline` переключает разметку с абзацев на `span` с видом блока.
 * Это не косметика: подсказка у термина (D57) встаёт внутрь `legend`,
 * где абзац запрещён разметкой, а описание там то же самое — второй
 * копии этого компонента быть не должно.
 */
export function Description({
  text,
  textRu,
  className = 'app-feature-text',
  inline = false,
}: {
  readonly text: string
  readonly textRu: string | null
  readonly className?: string
  readonly inline?: boolean
}) {
  const t = useT()
  const [original, setOriginal] = useState(false)
  const Para = inline ? 'span' : 'p'
  const Row = inline ? 'span' : 'div'
  // Вид блока у `span` задаётся классом: без него текст и кнопка
  // слиплись бы в одну строку.
  const block = inline ? ' app-block' : ''

  if (textRu === null) {
    return (
      <Para lang="en" className={`${className}${block}`}>
        {text}
      </Para>
    )
  }

  return (
    <>
      <Para lang="ru" className={`${className}${block}`}>
        {textRu}
      </Para>
      <Row className={`app-actions${block}`}>
        <button
          type="button"
          className="app-button app-button-quiet"
          aria-expanded={original}
          onClick={() => {
            setOriginal(!original)
          }}
        >
          {t('srd.original')}
        </button>
      </Row>
      {original && (
        <>
          <Para className={`app-slot-hint${block}`}>{t('srd.originalHint')}</Para>
          <Para lang="en" className={`${className} app-original${block}`}>
            {text}
          </Para>
        </>
      )}
    </>
  )
}
